import React from "react";
import "./ViewUser.css";

const ViewUser = ({ viewData }) => {
  return (
    <>
      {/* <h5 className="mt-2 mb-3 fw-bold">Personal Information</h5> */}
      <div className="row mb-3">
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>First Name</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.firstName}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Last Name</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.lastName}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Email</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.email}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Username</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.username}</div>
          </div>
        </div>

        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Mobile Number</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.mobileNo}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 view-col mb-0">
          <div className="row inner-row  mobile-line-row">
            <div className="col-sm-6 label"><span>Role</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">
              {viewData?.role?.map((item) => item)}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row mb-3">
        <div className="col-sm-6 view-col">
          <div className="row inner-row">
            <div className="col-sm-6 label"><span>Email</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.email}</div>
          </div>
        </div>
        <div className="col-sm-6 view-col">
          <div className="row inner-row">
            <div className="col-sm-6 label"><span>Username</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.username}</div>
          </div>
        </div>
      </div> */}
{/* 
      <div className="row mb-3">
        <div className="col-sm-6 view-col">
          <div className="row inner-row">
            <div className="col-sm-6 label"><span>Mobile Number</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.mobileNo}</div>
          </div>
        </div>
        <div className="col-sm-6 view-col">
          <div className="row inner-row">
            <div className="col-sm-6 label"><span>Role</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">
              {viewData?.role?.map((item) => item)}
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="row mb-3">
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Company Name:</div>
            <div className="col-sm-6 fw-bold">{viewData?.companyName}</div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Company CIN:</div>
            <div className="col-sm-6 fw-bold">{viewData?.companyCin}</div>
          </div>
        </div>
      </div> */}

      {/* <div className="row mb-3">
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Street Address:</div>
            <div className="col-sm-6 fw-bold">{viewData?.streetAddress}</div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">City:</div>
            <div className="col-sm-6 fw-bold">{viewData?.city}</div>
          </div>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">State:</div>
            <div className="col-sm-6 fw-bold">{viewData?.state}</div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Country:</div>
            <div className="col-sm-6 fw-bold">{viewData?.countryName}</div>
          </div>
        </div>
      </div> */}

      {/* <h5 className="mt-4 mb-3 fw-bold">Business Contact</h5>
      <div className="row mb-3">
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Contact Person:</div>
            <div className="col-sm-6 fw-bold">
              {viewData?.businessContactPerson}
            </div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Contact Email:</div>
            <div className="col-sm-6 fw-bold">
              {viewData?.businessContactEmail}
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Contact Mobile:</div>
            <div className="col-sm-6 fw-bold">
              {viewData?.businessContactMobile}
            </div>
          </div>
        </div>
      </div>

      <h5 className="mt-4 mb-3 fw-bold">Finance Contact</h5>
      <div className="row mb-3">
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Contact Person:</div>
            <div className="col-sm-6 fw-bold">
              {viewData?.financeContactPerson}
            </div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Contact Email:</div>
            <div className="col-sm-6 fw-bold">
              {viewData?.financeContactEmail}
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-sm-6">
          <div className="row">
            <div className="col-sm-6">Contact Mobile:</div>
            <div className="col-sm-6 fw-bold">
              {viewData?.financeContactMobile}
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default ViewUser;
